module.exports = __webpack_public_path__ + "img/direct_hit.9da43055.gif";